import scouting    from './scouting/module.config.json';
import spraying    from './spraying/module.config.json';
import consumables from './consumables/module.config.json';
import fertilizing from './fertilizing/module.config.json';
import picking     from './picking/module.config.json';
import auditing    from './auditing/module.config.json';
import settings    from './settings/module.config.json';
import system      from './system/module.config.json';
import { validateRegistry } from './validateRegistry';
import { ModuleConfig, ModuleRegistry } from './types';

const configs: ModuleConfig[] = [scouting, spraying, consumables, fertilizing, picking, auditing, settings, system] as ModuleConfig[];

export const MODULE_REGISTRY: ModuleRegistry = validateRegistry(configs);
export const MODULE_KEYS: string[] = Object.keys(MODULE_REGISTRY);
